import(/* webpackMode: "eager" */ "/app/packages/frontend/app/global-error.tsx");
